<!--
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2024-02-21 10:07:36
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-06-26 16:06:53
 * @FilePath: /visaai-platform/src/views/financial/Financial.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="financial">
    <div class="financial-sidebar">
      <el-menu router :default-active="$route.path">
        <el-menu-item index="/financial/recharge">
          <img
            src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/ic_chongzhi%402x.png"
            alt
          />
          <img
            class="active"
            src="https://bn-visas.oss-cn-hangzhou.aliyuncs.com/onlineImg/ic_chongzhi_active%402x.png"
            alt
          />
          <span slot="title">{{ $t('financial.sidebar.rechargeCenter') }}</span>
        </el-menu-item>
        <el-menu-item index="/financial/coupon" v-if="userInfo.bizRole === 'A'">
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/coupon-account.png"
            alt
          />
          <img
            class="active"
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/coupon-account_active.png"
            alt
          />
          <span slot="title">{{ $t('financial.sidebar.couponDetail') }}</span>
        </el-menu-item>
        <!-- <el-submenu index="/order-list">
          <template slot="title">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visa-account.png"
              alt
            />
            <img
              class="active"
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visa-account_active.png"
              alt
            />
            <span slot="title" style="font-size: 13px; color: rgba(0, 0, 0, 0.54)">签证费账户</span>
          </template>
          <el-menu-item index="/financial/usa" style="min-width:1px">美国</el-menu-item>
          <el-menu-item index="/financial/malay" style="min-width:1px">马来西亚</el-menu-item>
        </el-submenu> -->
        <!-- <el-menu-item index="/financial/mall" v-if="this.userInfo.channel !== 'lyb'">
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/mall-account.png"
            alt
          />
          <img
            class="active"
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/mall-account_active.png"
            alt
          />
          <span slot="title">现金账户</span>
        </el-menu-item> -->
      </el-menu>
    </div>
    <!-- <el-scrollbar> -->
    <div class="financial-main">
      <router-view></router-view>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "financial",
  computed: {
    ...mapGetters(["userInfo"]),
  },
};
</script>

<style lang="scss">
.financial {
  height: 100%;
  display: flex;
  &-sidebar {
    width: 150px;
    height: 100vh;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.06);
    position: relative;
    box-sizing: border-box;
    background-color: $color-white;
    // overflow: hidden;
  }
  &-main {
    padding: 10px 20px 0 20px;
    width: calc(100% - 150px);
    box-sizing: border-box;
  }
  .page-section:last-child {
    margin-bottom: 0;
  }
}
</style>
